<template>
    <div class="row">
    <h5 class="nota-parcial">Nota: {{notaTotal}}</h5>
    <div class="row" v-if="!bolsistaError">
        <avaliacao-relatorio-list-bolsistas
                @get-edital-status ="setBolsistaStatus"
                @set-nota-parcial="setNotaParcialBolsistas"
            />
        </div>
        <div v-else class="row">
			<div class="row">
				<div class="col s12"  >
					<fieldset><legend>Bolsistas</legend>
						<div class= "card-panel amber lighten-3">
							<span>
								{{bolsistasMessage}}
							</span>
						</div>
					</fieldset>
				</div>
            </div>
        </div>
        <div class="row" v-if="!voluntarioError">
            <avaliacao-relatorio-list-voluntarios
                @get-edital-status ="setVoluntarioStatus"
                @set-nota-parcial="setNotaParcialVoluntarios"
                
            />
        </div>
		<div v-else class="row">
			<div class="row">
				<div class="col s12"  >
					<fieldset><legend>Voluntários</legend>
						<div class= "card-panel amber lighten-3">
							<span>
								{{voluntariosMessage}}
							</span>
						</div>
					</fieldset>
				</div>
			</div>
		</div>
    </div>

</template>
<script>
import AvaliacaoRelatorioListBolsistas from './AvaliacaoRelatorioListBolsistas.vue';
import AvaliacaoRelatorioListVoluntarios from './AvaliacaoRelatorioListVoluntarios.vue';

export default {
    name:'AvaliacaoRelatorioList',
    components:{
        AvaliacaoRelatorioListBolsistas,
        AvaliacaoRelatorioListVoluntarios
        
    },
    data(){
        return {
            voluntarioError: false,
            bolsistaError: false,
            voluntariosMessage: '',
            bolsistasMessage: '',
            qtdVoluntarios: 0,
            qtdBolsistas: 0,
            notaVoluntarios: 0,
            notaBolsistas: 0,
            notaTotal: 0,

        };
    },
    methods:{
        setNotaParcialVoluntarios({nota,qtd}){
            this.$set(this,'qtdVoluntarios',qtd);
            this.$set(this,'notaVoluntarios',nota);
            this._setNotaParcial();
        },
        setNotaParcialBolsistas({nota,qtd}){
            this.$set(this,'qtdBolsistas',qtd);
            this.$set(this,'notaBolsistas',nota);
            this._setNotaParcial();
        },
        _setNotaParcial(){
            if(this.notaVoluntarios == undefined)
                this.$set(this,"notaVoluntarios",0);
            if(this.notaBolsistas == undefined)
                this.$set(this,"notaBolsistas",0)
            let qtdTotal = this.qtdVoluntarios + this.qtdBolsistas;
            let notaTotal = Number(this.notaVoluntarios) + Number(this.notaBolsistas);
            notaTotal = notaTotal / qtdTotal;
            if(isNaN(notaTotal))
                notaTotal = 0;
            this.$set(this,'notaTotal',notaTotal.toFixed(2));
        },
        setVoluntarioStatus({error, message}){
            this.$set(this,'voluntarioError',error);
            this.$set(this,'voluntariosMessage',message);
        },
        setBolsistaStatus({error, message}){
            this.$set(this,'bolsistaError',error);
            this.$set(this,'bolsistasMessage',message);
        }
        
    }
    
}
</script>
<style scoped>
    .nota-parcial{
        font-size: 18px !important;
        padding-left: 85%;
    }
</style>